import { useAuthLoaderData } from '@/loaders/auth/useAuthLoaderData';
import styles from './Dashboard.section.module.css';
import Summaries from './sections/summaries/Summaries';

export default function DashboardSection() {  
  const username  = useAuthLoaderData()?.user?.name  

  return (
    <div className={styles.section}>   
      <div className={styles.nav}>
        <span className={styles.title}>
          ¡Hola, <span>{username}</span>!
        </span>  
        <p>Aqui tienes un resumen general de tus proveedores</p>      
      </div>   
      <Summaries />                                                 
    </div>
  )
}
